import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import pt from './locales/pt.json';

const PT_COUNTRIES = ['PT', 'BR', 'AO', 'MZ', 'TL', 'CV', 'GW', 'ST', 'MO'];

const storedLang = localStorage.getItem('dd-lang');

i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, pt: { translation: pt } },
  lng: storedLang || 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

// Auto-detect language from IP if no stored preference
if (!storedLang) {
  fetch('https://ipapi.co/json/')
    .then(res => res.json())
    .then(data => {
      if (data.country_code && PT_COUNTRIES.includes(data.country_code)) {
        i18n.changeLanguage('pt');
        localStorage.setItem('dd-lang', 'pt');
      } else {
        localStorage.setItem('dd-lang', 'en');
      }
    })
    .catch(() => {
      // Fallback: check browser language
      const browserLang = navigator.language || '';
      if (browserLang.startsWith('pt')) {
        i18n.changeLanguage('pt');
        localStorage.setItem('dd-lang', 'pt');
      }
    });
}

export default i18n;
